import { useSelector } from "react-redux";
import Slider from "react-styled-carousel";

const ServicePicker = ({ services, payload, selectService, compactMobile = false }) => {
  const config = useSelector((x) => x.Config);
  return (
    <div
      className="row justify-content-center row-gap-3 column-gap-3"
      style={{ padding: "40px 0px" }}
    >
      <div className="col-12 text-center">
        <span
          style={{ fontSize: "18px", color: "#656565" }}
          className="fw-bold"
        >
          1. Choose Your Service
        </span>
      </div>
      <Slider
        autoSlide={false}
        showDots={false}
        responsive={[
          { breakPoint: 1400, cardsToShow: 8 },
          { breakPoint: 1200, cardsToShow: 7 },
          { breakPoint: 992, cardsToShow: 6 },
          { breakPoint: 768, cardsToShow: 4 },
          { breakPoint: 470, cardsToShow: 3 },
          { breakPoint: 360, cardsToShow: compactMobile ? 3 : 2 },
          { breakPoint: 0, cardsToShow: 2 },
        ]}
        infinite={false}
        LeftArrow={
          <i
            className="fa-solid fa-chevron-left fs-4 cursor-pointer"
            style={{ position: "absolute", top: "calc(50% - 5px)", left: 0 }}
          ></i>
        }
        RightArrow={
          <i
            className="fa-solid fa-chevron-right fs-4 cursor-pointer"
            style={{ position: "absolute", top: "calc(50% - 5px)", right: 0 }}
          ></i>
        }
      >
        {/* <div
          className="row justify-content-start column-gap-3 row-gap-3 px-4 select-category-chip-container"
          style={{
            flexWrap: "nowrap",
            width: "100%",
            overflowX: "auto",
          }}
        > */}
        {services.map((e) => (
          <div
            key={`service-card-${e.id}`}
            className={`select-service-card ${
              e.id === payload.serviceId ? "selected" : ""
            }`}
            onClick={() => selectService(e.id)}
          >
            <img
              src={`${config?.["base_urls"]?.["services_image_url"]}/${e?.["icon"]}`}
              alt=""
            />
            <span>{e.name}</span>
          </div>
        ))}
        {/* </div> */}
      </Slider>
    </div>
  );
};

export default ServicePicker;
